



































































































/* eslint-disable */

import {
  defineComponent, computed, ref, Ref, onMounted, reactive, watch,
} from '@vue/composition-api';

import { Buffer } from 'buffer';

import useFiles from '@/use/useFiles';
import useRouter from '@/use/useRouter';

type FileJSON = {
  header: string;
  footer: string;
  originalSize: number;
  wordPairs: {
    next: number;
    key: string;
    word: string;
    encoding: string;
    position: {
      from: number;
      to: number;
    };
    size: {
      key: number;
      word: number;
      tail: number;
      total: number;
    };
    wordText: string;
    keyText: string;
  }[];
};

const Editor = defineComponent({
  setup(props) {
    const lastSave: Ref<string | Date> = ref('');
    const saving = ref(false);
    const filepath = ref('');

    const { parser, getFile, hasFile, saveFile, converter, downloadFile } = useFiles();
    const { route } = useRouter();

    let file = ref({} as FileJSON);
    let companionFile = ref({} as FileJSON);

    const offset = ref(-1);
    const offsetInput = ref(0);

    function obtainFile() {
      const fn = route.value.params.fsKey?.replace('utranslate-file-', '');
      if (hasFile(route.value.params.fsKey)) {
        if (hasFile(`utranslate-json-${fn}`)) {
          const json = JSON.parse(getFile(`utranslate-json-${fn}`));
          file.value = json as FileJSON;
        } else {
          if (offset.value !== -1) {
            saveFile(
              `utranslate-json-${fn}`,
              JSON.stringify(parser.uasset(Buffer.from(getFile(route.value.params.fsKey) as string, 'hex'), offset.value))
            )
            file.value = JSON.parse(getFile(`utranslate-json-${fn}`)) as FileJSON;
          }
        }
      }
    }

    const companion = ref('');
    const companionInput = ref('');

    function obtainCompanion() {
      const companionFileName = localStorage.getItem(route.value.params.fsKey?.replace('utranslate-file-', 'utranslate-companion-'));
      if (companionFileName) {
        if (hasFile(companionFileName)) companionFile.value = JSON.parse(getFile(companionFileName));
      }
    }

    function setCompanion() {
      companion.value = `utranslate-json-${companionInput.value}`;
      localStorage.setItem(route.value.params.fsKey?.replace('utranslate-file-', 'utranslate-companion-'), companion.value);
      obtainCompanion();
    }

    function setOffset() {
      offset.value = offsetInput.value;
      try {
        obtainFile();
      } catch (e) {
        console.error('seems to have an error when parsing');
      }
    }

    watch(route, () => {
      file.value = {} as FileJSON;
      companionFile.value = {} as FileJSON;
      offset.value = -1;
      offsetInput.value = 0;
      companion.value = '';
      companionInput.value = '';
      obtainFile();
      obtainCompanion();
    }, { deep: true });

    const currentSize = computed(() => {
      let checkWordPairsSize = 0;
      file.value.wordPairs.forEach((elm) => {
        checkWordPairsSize += (elm.key.length / 2) + (elm.word.length / 2) + 4 + 4 + (elm.size.tail);
      });
      return (file.value.header.length / 2) + (file.value.footer.length / 2) + checkWordPairsSize;
    });

    function reComputeSize(index: number) {
      file.value.wordPairs[index].word = Buffer
        .from(file.value.wordPairs[index].wordText, (file.value.wordPairs[index].encoding === 'ascii') ? 'ascii' : 'utf16le')
        .toString('hex');
      if (file.value.wordPairs[index].encoding === 'ascii') file.value.wordPairs[index].word = `${file.value.wordPairs[index].word}00`; // not so sure about this but found a lot ASCII with 00 padding
    }

    function setWordText(event: Event, index: number) {
      file.value.wordPairs[index].wordText = (event.target as any).value;
      reComputeSize(index);
    }

    onMounted(() => {
      document.onkeyup = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.which === 83) {
          console.log('save');
          e.preventDefault();
          return false;
        }
      };
    });

    function save() {
      localStorage.setItem(
        route.value.params.fsKey?.replace('utranslate-file-', 'utranslate-json-'),
        JSON.stringify(file.value),
      )
      lastSave.value = new Date();
    }

    function exportFile() {
      save();
      const hex = converter.uasset(file.value);
      // const original = getFile(route.value.params.fsKey);
      // console.log(original.length);
      // console.log(hex.length);
      // console.log('---');
      // const hexArr = hex.split('');
      // original.split('').forEach((char, index) => {
      //   const res = char === hexArr[index];
      //   if (!res) {
      //     console.log('index', index, '; original', char, '; hex', hexArr[index]);
      //   }
      // });
      // console.log(hex === original);
      downloadFile(Buffer.from(hex, 'hex'), route.value.params.fsKey?.replace('utranslate-file-', 'edited-'));
    }

    return {
      companionFile,
      companionInput,
      setCompanion,
      lastSave,
      saving,
      save,
      filepath,
      reComputeSize,
      setWordText,
      currentSize,
      file,
      offsetInput,
      setOffset,
      exportFile,
      hex(string: string, group = 2) {
        if (group === 2) return (string.match(/.{2}/g) || ['']).join(' ');
        return (string.match(/.{4}/g) || ['']).join(' ');
      },
    };
  },
});

export default Editor;
